import { render, staticRenderFns } from "./PositionColumns.vue?vue&type=template&id=39735eab&scoped=true&"
import script from "./PositionColumns.vue?vue&type=script&lang=js&"
export * from "./PositionColumns.vue?vue&type=script&lang=js&"
import style0 from "./PositionColumns.vue?vue&type=style&index=0&id=39735eab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39735eab",
  null
  
)

export default component.exports